import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { Pair } from 'src/app/shared/models/main/pair'
import { Word } from 'src/app/shared/models/main/word'
import { Languages } from '../../enums/enums'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'

@Component({
  selector: 'ddc-flash-card',
  templateUrl: './ddc-flash-card.component.html',
  styleUrl: './ddc-flash-card.component.scss',
  imports: [AngularMaterialsModules, CommonModule, DdcCountryFlagComponent],
})
export class DdcFlashCardComponent implements OnInit {
  @Input() data: Word | Pair | null = null
  @Input() type: 'word' | 'pair' = 'word'
  @Input() theme: 'light' | 'dark' | 'paper' = 'light'
  @Input() isFlipped: boolean = false

  @Output() cardClick = new EventEmitter<void>()

  constructor() {}

  ngOnInit(): void {}

  onCardClick(): void {
    this.cardClick.emit()
  }

  // Type guards
  isWord(): boolean {
    return this.type === 'word' && this.data && 'word' in this.data && !('word_1' in this.data)
  }

  isPair(): boolean {
    return this.type === 'pair' && this.data && 'word_1' in this.data && 'word_2' in this.data
  }

  // Getters for type-safe access
  get wordData(): Word | null {
    return this.isWord() ? (this.data as Word) : null
  }

  get pairData(): Pair | null {
    return this.isPair() ? (this.data as Pair) : null
  }

  // For word type
  hasDefinition(): boolean {
    if (this.isWord()) {
      const word = this.data as Word
      return word?.definition && word.definition.trim().length > 0
    }
    return false
  }

  hasExample(): boolean {
    if (this.isWord()) {
      const word = this.data as Word
      return word?.example && word.example.trim().length > 0
    }
    return false
  }

  // For pair type - check if either word has definition or example
  pairHasDefinition(): boolean {
    if (this.isPair()) {
      const pair = this.data as Pair
      return (
        (pair?.word_1?.definition && pair.word_1.definition.trim().length > 0) ||
        (pair?.word_2?.definition && pair.word_2.definition.trim().length > 0)
      )
    }
    return false
  }

  pairHasExample(): boolean {
    if (this.isPair()) {
      const pair = this.data as Pair
      return (
        (pair?.word_1?.example && pair.word_1.example.trim().length > 0) ||
        (pair?.word_2?.example && pair.word_2.example.trim().length > 0)
      )
    }
    return false
  }

  // Get language display name from language code
  getLanguageName(code: string): string | null {
    for (const key in Languages) {
      if ((Languages as { [key: string]: readonly string[] })[key][1] === code) {
        return (Languages as { [key: string]: readonly string[] })[key][0]
      }
    }
    return null
  }
}
